import { Events } from '../Events';
import { CoreController } from '../CoreController';
import { isIphone } from '../../utils/GameEngine';
import {SaveDataKeys} from './SaveDataKeys';

export interface SettingsSaveData {
    settingsSFX?: SettingState;
    settingsMusic?: SettingState;
    settingsVibrate?: SettingState;
}

export enum SettingState {
    On = 'On',
    Off = 'Off',
    Locked = 'Locked'
}

export class SettingsManager {
    private static _instance: SettingsManager;
    private settingsSFX: SettingState;
    private settingsMusic: SettingState;
    private settingsVibrate: SettingState;

    constructor() {
        this.retrieveSettings().then((data: SettingsSaveData): void => {
            // tslint:disable-next-line:max-line-length
            const vibrateAvailable: boolean = (window.navigator !== null) && (window.navigator.vibrate !== null) && (!isIphone());
            this.settingsVibrate = data.settingsVibrate;
            if (!this.settingsVibrate) {
                if (vibrateAvailable) {
                    this.settingsVibrate = SettingState.On;
                } else {
                    this.settingsVibrate = SettingState.Locked;
                }
            } else if (!vibrateAvailable) {
                this.settingsVibrate = SettingState.Locked;
            }

            let toSave: boolean = false;
            this.settingsMusic = data.settingsMusic || SettingState.On;
            if (this.settingsMusic === SettingState.Locked) {
                this.settingsMusic = SettingState.On;
                toSave = true;
            }
            this.settingsSFX = SettingState.Locked;
            // this.settingsSFX = data.settingsSFX || SettingState.On;
            // if (this.settingsSFX === SettingState.Locked) {
            //     this.settingsSFX = SettingState.On;
            //     toSave = true;
            // }
            // if (toSave) {
            //     this.saveSettings();
            // }
        });
    }

    public static getInstance(): SettingsManager {
        return this._instance || (this._instance = new this());
    }

    public getSettingsSFX(): SettingState {
        return this.settingsSFX;
    }

    public getSettingsMusic(): SettingState {
        return this.settingsMusic;
    }

    public getSettingsVibrate(): SettingState {
        return this.settingsVibrate;
    }

    public setSettingsSFX(state: SettingState): void {
        this.settingsSFX = state;
        this.saveSettings();
        dispatchEvent(new CustomEvent(Events.settingSFXSet, {
            detail: {
                state: state
            }
        }));
    }

    public setSettingsMusic(state: SettingState): void {
        this.settingsMusic = state;
        this.saveSettings();
        dispatchEvent(new CustomEvent(Events.settingMusicSet, {
            detail: {
                state: state
            }
        }));
    }

    public setSettingsVibrate(state: SettingState): void {
        this.settingsVibrate = state;
        this.saveSettings();
    }

    private retrieveSettings(): Promise<SettingsSaveData> {
        return CoreController.getInstance().getManager().retrieveSettings();
    }

    private saveSettings(): void {
        const saveData: SettingsSaveData = {};
        if (this.settingsVibrate !== SettingState.Locked) {
            saveData.settingsVibrate = this.settingsVibrate;
        }
        if (this.settingsMusic !== SettingState.Locked) {
            saveData.settingsMusic = this.settingsMusic;
        }
        if (this.settingsSFX !== SettingState.Locked) {
            saveData.settingsSFX = this.settingsSFX;
        }
        CoreController.getInstance().getManager().saveData(SaveDataKeys.settingsMusic, this.settingsMusic);
        CoreController.getInstance().getManager().saveData(SaveDataKeys.settingsSFX, this.settingsSFX);
        CoreController.getInstance().getManager().saveData(SaveDataKeys.settingsVibrate, this.settingsVibrate);
    }
}